import type { CSSProperties } from 'react'

interface Styles {
	container: CSSProperties
	title: CSSProperties
	button: CSSProperties
}

export const styles: Styles = {
	container: {
		height: '65dvh',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column',
		textAlign: 'center',
		margin: '1rem',
	},
	title: {
		font: 'var(--sem-font-heading-l-weight) var(--sem-font-heading-l-size) / var(--sem-font-heading-l-line-height) var(--mango-headings-font)',
		marginBottom: '1rem',
	},
	button: {
		font: 'var(--sem-font-action-m-weight) var(--sem-font-action-m-size) / var(--sem-font-action-m-line-height) var(--mango-headings-font)',
		textTransform: 'uppercase',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '0.25rem',
		cursor: 'pointer',
		boxSizing: 'border-box',
		margin: '2rem 0 0',
		border: 0,
		height: '2.75rem',
		padding: '0 2rem',
		minWidth: '350px',
		color: '#fff',
		backgroundColor: '#131313',
	},
}
